module.exports = __webpack_public_path__ + "static/img/inbox.557c2392.svg";